<template>
  <template v-if="editionMode">
    <div
      class="fm-form-input w-full bg-white px-3 py-2"
      :class="label ? 'mt-2' : ''"
    >
      <label v-if="label" :for="name">
        {{ label }}
        <span v-if="label && required" class="text-red-600">*</span>
      </label>
      <DatePicker
        v-model:date="dateValue"
        :view="view"
        :events="events"
        :min-date="minDate"
        :max-date="maxDate"
        :extra-dots="extraDots"
        :required="required"
        :name="name"
      />
      <button
        v-if="!required && dateValue"
        type="button"
        tabindex="-1"
        class="absolute inset-y-0 right-0 mr-3 flex items-center pl-3 text-red-600"
        @click.prevent="clearDateValue"
      >
        <FontAwesomeIcon :icon="['fal', 'times']" />
      </button>
    </div>
    <template v-if="errors">
      <ErrorContainer :error-key="name" :errors="errors" />
    </template>
  </template>
  <template v-else>
    <BaseShowLabel
      :label="label"
      :model-value="cDisplayedValueWhenNotEditionMode"
    />
  </template>
</template>

<script>
import moment from 'moment'
import DatePicker from '@c/addf-package/components/BaseShowEditDatePicker/Component/DatePicker.vue'
import BaseShowLabel from '@c/addf-package/components/BaseLabel/BaseShowLabel.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ErrorContainer from '@c/addf-package/components/BaseShowEditInput/ErrorContainer.vue'

export default {
  name: 'BaseShowEditDatePickerv2',
  components: { ErrorContainer, FontAwesomeIcon, BaseShowLabel, DatePicker },
  props: {
    date: {
      type: String,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    editionMode: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    view: {
      type: String,
      required: false,
      default: 'monthly'
    },
    events: {
      type: Array,
      required: false,
      default: null
    },
    disableDatePicker: {
      type: Boolean,
      required: false,
      default: false
    },
    errors: {
      type: [Object, Array],
      required: false,
      default: () => []
    },
    todayDefault: {
      type: Boolean,
      required: false,
      default: false
    },
    minDate: {
      type: String,
      required: false,
      default: null
    },
    maxDate: {
      type: String,
      required: false,
      default: null
    },
    extraDots: {
      type: Array,
      required: false,
      default: () => []
    },
    name: {
      type: String,
      required: false,
      default: 'inputdate'
    }
  },
  emits: ['update:date'],
  computed: {
    cDisplayedValueWhenNotEditionMode() {
      let _moment = moment(this.dateValue)
      if (_moment.isValid()) {
        return _moment.format('DD/MM/YYYY')
      }
      return ''
    },
    dateValue: {
      set(value) {
        if (!value) {
          this.$emit('update:date', value)
        } else {
          let _moment = moment(value, 'DD/MM/YYYY')

          if (_moment.isValid()) {
            this.$emit('update:date', _moment.format('YYYY-MM-DD'))
          } else {
            this.$emit('update:date', null)
          }
        }
      },
      get() {
        if (this.date) {
          return moment(this.date).toDate()
        } else {
          return null
        }
      }
    }
  },
  mounted() {
    if (this.todayDefault && !this.dateValue) {
      this.dateValue = moment().toDate()
    }
  },
  methods: {
    clearDateValue() {
      this.dateValue = null
    }
  }
}
</script>
